<script lang="ts" setup>
import { computed, toRefs } from 'vue';

import { marketService } from '@exchange/libs/market/service/src';
import { usePriceTicks } from '@exchange/libs/price-ticks/service/src';

import PriceTicksHistoryList from './PriceTicksHistoryList.vue';

const props = defineProps({
  marketId: { type: String, required: true },
  showTitle: { type: Boolean, default: true },
});

const { marketId } = toRefs(props);

const { getMarket, getMarketPrecision } = marketService;

const { priceTicks, priceTicksAreLoading } = usePriceTicks(marketId);

const market = computed(() => getMarket(marketId.value));
const marketPrecisions = computed(() => getMarketPrecision(market.value));
</script>

<template>
  <ot-module-container
    :key="marketId"
    class="price-ticks-history-container"
    :loading="priceTicksAreLoading"
    :title="showTitle ? $t('modules.marketHistory.title') : ''"
    :with-bottom-padding="true"
  >
    <template #main-content>
      <price-ticks-history-list
        :price-ticks="priceTicks"
        :market-id="marketId"
        :amount-precision="marketPrecisions.amount"
        :market-precision="marketPrecisions.market"
      />
    </template>
  </ot-module-container>
</template>

<style lang="scss" scoped>
.price-ticks-history-container {
  border: 0;
}
</style>
